import { Module, ActionContext } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';
import { StateList } from '@/shared/statesList';
import { StoreInputParameters } from '@/services/idbStore.interface';
import idb, { PRODUCTS_STORE_NAME, TENANTS_STORE_NAME } from '@/services/indexedDb.service';
// import { i18nService } from '@sonicwall/unified-ui-framework/src/shared/i18n-service';

export const defaultSelectedCustomer = 'All tenants';
export interface ProductsStoreState {
  productsList: [];
  customersList: string[];
  selectedCustomer: string;
  secureUpdateData: [];
  productDetails: any;
  selectedSerialNumer: string;
  selectedProductType: string;
  batchid: string;
  isUserRead: boolean;
  //  filter values
  productTypeSelectValue: string;
  selectedDateRange: string;
  registeredOnSelectValue: string;
  searchInputChips: [];
  customDateFilter: string;
  regDtRangeValue: string;
  regDtStartDate: string;
  regDtEndDate: string;
  lastRegFilterIdSelected: string;
  selectedColumnKeys: any;
  expiringOnSelectValue: string;
  expiringOnSelectVal: string;
  firmwareFilterValue: string;
  ztTypeSelectedValue: string;
  widths: any;
  sortData: any[];
  skipLoading: string;
  ztnaMsg: string;
  // registerProductView: boolean;
  // createCustomerView: boolean;
  // defaultTabView: boolean;
  initial: {
    productsList: [];
    customersList: string[];
    selectedCustomer: string;
    secureUpdateData: [];
    productDetails: any;
    batchid: string;
    productTypeSelectValue: string;
    selectedDateRange: string;
    registeredOnSelectValue: string;
    searchInputChips: [];
    customDateFilter: string;
    regDtRangeValue: string;
    regDtStartDate: string;
    regDtEndDate: string;
    lastRegFilterIdSelected: string;
    selectedColumnKeys: any;
    expiringOnSelectValue: string;
    expiringOnSelectVal: string;
    firmwareFilterValue: string;
    ztTypeSelectedValue: string;
    selectedCustomerId: string;
  };
  registerOrTransfer: Map<number, boolean>;
  uniqueID: Map<number, string>;
  awsSerialNumber: Map<number, Object>;
  freeTrailSerNo: Map<number, Object>;
  secureUpgrade: Map<number, Object>;
  storageSata: Map<number, Object>;
  assignToken: Map<number, Object>;
  secureUpdateSelected: Map<number, Object>;
  selectedTab: any;
  selectedCustomerId: string;
  validateSerialNumberData: any;
}
export default {
  state: {
    productsList: [],
    customersList: [],
    selectedCustomer: defaultSelectedCustomer,
    secureUpdateData: [],
    productDetails: {},
    selectedSerialNumer: '',
    selectedProductType: '',
    batchid: '',
    productTypeSelectValue: 'All',
    selectedDateRange: 'All',
    registeredOnSelectValue: 'all',
    searchInputChips: [],
    customDateFilter: '',
    regDtRangeValue: '',
    regDtStartDate: '',
    regDtEndDate: '',
    lastRegFilterIdSelected: '',
    selectedColumnKeys: [],
    expiringOnSelectValue: 'All',
    expiringOnSelectVal: 'All',
    firmwareFilterValue: '',
    ztTypeSelectedValue: '',
    widths: {
      friendlyName: '',
      serNo: '',
      productGroup: '',
      productType: '',
      productName: '',
      registrationDate: '',
      casNodeCount: '',
      supportExpiry: '',
    },
    sortData: [],
    skipLoading:'NO',
    ztnaMsg:'',
    initial: {
      productsList: [],
      customersList: [],
      productTypeSelectValue: 'All',
      selectedCustomer: defaultSelectedCustomer,
      secureUpdateData: [],
      productDetails: {},
      batchid: '',
      selectedDateRange: 'All',
      registeredOnSelectValue: 'all',
      searchInputChips: [],
      customDateFilter: '',
      regDtRangeValue: '',
      regDtStartDate: '',
      regDtEndDate: '',
      lastRegFilterIdSelected: '',
      selectedColumnKeys: [],
      expiringOnSelectValue: 'All',
      expiringOnSelectVal: 'All',
      firmwareFilterValue: '',
      ztTypeSelectedValue: '',
      selectedCustomerId: '',
    },
    uniqueID: new Map(),
    awsSerialNumber: new Map(),
    freeTrailSerNo: new Map(),
    secureUpgrade: new Map(),
    secureUpdateSelected: new Map(),
    storageSata: new Map(),
    registerOrTransfer: new Map(),
    assignToken: new Map(),
    isUserRead: false,
    selectedTab: { id: 'productdetails', props:  [{ tabId: 'productdetails', label: 'Product Details' }] },
    selectedCustomerId: '',
    validateSerialNumberData: {},
  },
  mutations: {
    setProductsList(state, payload) {
      state.productsList = payload;
    },
    editWidth(state: any, payload) {
      state.widths[payload.propertyName] = payload.width;
    },
    saveSort(state: any, payload) {
      state.sortData = [];
      state.sortData.push(payload);
    },
    setSelectedSerialNumber(state, payload) {
      state.selectedSerialNumer = payload;
    },
    productMutate: (state: any, payload) => state[payload.property] = payload.with,
    setCutomersList: (state: any, payload) => state.customersList = payload,
    mutate: (state: any, payload) => state[payload.property] = payload.with,
    editProduct: (state: any, payload) => state.productDetails[payload.property] = payload.with,
    assigner(state: any, payload) {
      try { state.appVersion; } catch (e) { }
      state[payload] = state.initial[payload];
    },
    mapMutate: (state: any, payload) => {
      state[payload.property].set(payload.key, payload.value);
    },
    assignBatchid: (state: any, payload) => {
      state.batchid = payload;
    },
    setFiltersState(state: any, payload) {
      Object.keys(payload)
        .forEach((filter: string) => {
          if (state[filter] !== undefined) {
            if (filter === 'selectedColumnKeys' && (!payload[filter] || !payload[filter].length)) {
              // donot mutate
            } else {
              state[filter] = (payload[filter]);
            }
          }
        });
    },
    // setUserReadStatus: (state, payload) => {
    //   state.isUserRead = payload;
    // },
    setSkipLoading:(state: any, payload) => state.skipLoading = payload,
    setZtnaMsg:(state: any, payload) => state.ztnaMsg = payload,
    setCurrentTab:(state: any, payload) => {
      if (payload.updateMode === 'id') {
        state.selectedTab.id = payload.value;
      } else if (payload.updateMode === 'props' && payload.updateOperation === 'assign') {
        state.selectedTab.props = payload.value;
      } else {
        state.selectedTab.props.push(payload.value);
      }
    },
    setValidateSerialNumberData: (state: any, payload) => {
      state.validateSerialNumberData = payload;
    },
  },
  actions: {
    saveFilterState({ }, payload) {
      const endpoint = 'product/save-column-preference';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    resetStore(context: ActionContext<ProductsStoreState, RootStoreState>) {
      const keys = context.state.initial ? Object.keys(context.state.initial) : [];
      keys.forEach((stateT: any) => {
        if (stateT !== 'initial') context.commit('assigner', stateT);
      });
    },
    // getProductsList({}, payload) {
    //   const endpoint = 'users/productlist-customer';
    //   return ApiServiceWrapper.post(endpoint , payload);
    // },
    async getProductsList({ }, payload, forceFetch = payload.forceFetch) {
      const endpoint = 'users/productlist-customer';
      const request: StoreInputParameters = { endpoint, payload, forceFetch, objectName: PRODUCTS_STORE_NAME, httpMethod: 'post' };
      const idbData = await idb.getData(request, ['MSWAPP:SUCCESS', 'MSWAPP:EMPTYPRODUCTLIST', 'MSWAPP:EMPTYPRODLIST'], 'content');
      return Promise.resolve(idbData);
    },
    async saveProductsList({ }, payload) {
      await idb.saveData(PRODUCTS_STORE_NAME, payload);
      return;
    },
    async saveTenantList({ }, payload) {
      await idb.saveData(TENANTS_STORE_NAME, payload);
      return;
    },
    getProductDetail(context: ActionContext<ProductsStoreState, RootStoreState>, serialNumber: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/product-detail?serialnumber=${serialNumber}`;
      return ApiServiceWrapper.get(endpoint);
    },
    // tslint:disable-next-line: no-unused
    getMsspAppliances(context: ActionContext<ProductsStoreState, RootStoreState>, data: any) {
      const reqEndPoint = 'mssp/get-mssp-appliances';
      return ApiServiceWrapper.post(reqEndPoint, data);
    },
    // tslint:disable-next-line: no-unused
    editProductProvision(context: ActionContext<ProductsStoreState, RootStoreState>, data: any) {
      context.commit('startLoading', null, { root: true });
      const reqEndPoint = 'mssp/allocatemsspproductservices';
      return ApiServiceWrapper.post(reqEndPoint, data);
    },
    // tslint:disable-next-line: no-unused
    renameFriendlyName(context: ActionContext<ProductsStoreState, RootStoreState>, reqPayload: any) {
      const endpoint = 'product/product-rename';
      return ApiServiceWrapper.post(endpoint, reqPayload);
    },
    // tslint:disable-next-line: no-unused
    actionThreeAndFreeIsCSESeed(context: ActionContext<ProductsStoreState, RootStoreState>, reqPayload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/complete-cse-registration';
      return ApiServiceWrapper.post(endpoint, reqPayload);
    },
    deleteMssp(context: ActionContext<ProductsStoreState, RootStoreState>, reqPayload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `mssp/deprovision-MSSP?msspId=${reqPayload.msspId}`;
      return ApiServiceWrapper.post(endpoint, {});
    },
    deleteTenant(context: ActionContext<ProductsStoreState, RootStoreState>, reqPayload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/delete-productgroup';
      return ApiServiceWrapper.post(endpoint, reqPayload);
    },
    // tslint:disable-next-line: no-unused
    serialNumberValidation(context: ActionContext<ProductsStoreState, RootStoreState>, req: any) {
      const endpoint = 'product/validate-serial-number';
      return ApiServiceWrapper.post(endpoint, req);
    },
    // tslint:disable-next-line: no-unused
    initiateTransfer(context: ActionContext<ProductsStoreState, RootStoreState>, req: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/initiate-transfer';
      return ApiServiceWrapper.post(endpoint, req);
    },
    approveRejectRequest(context: ActionContext<ProductsStoreState, RootStoreState>, req: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/approve-reject-device';
      return ApiServiceWrapper.post(endpoint, req);
    },
    // tslint:disable-next-line: no-unused
    getCustomerName(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      // context.commit('startLoading', null, { root: true });
      let endpoint = '';
      if (payload === 'register') {
        endpoint = 'users/get-productgroup-details-for-user?isforced=true&applicationFunctionality=ACCESSTYPEPRODMGMT&skipProducts=YES';
      } else if (payload === 'tenantMgmt') {
        endpoint = 'users/get-productgroup-details-for-user?skipProducts=YES&showTenantsOnly=YES';
      } else {
        endpoint = 'users/get-productgroup-details-for-user';
      }
      return ApiServiceWrapper.get(endpoint);
    },
    // tslint:disable-next-line: no-unused
    registerSerialNumber(context: ActionContext<ProductsStoreState, RootStoreState>, req: any) {
      // context.commit('startLoading', null, { root: true });
      const endpoint = 'product/register-serial';
      return ApiServiceWrapper.post(endpoint, req);
    },
    // tslint:disable-next-line:no-unused
    getMaintainanceKeyValue(context: ActionContext<ProductsStoreState, RootStoreState>, request: any) {
      const endpoint = `product/get-maintainence-key?serialnumber=${request.serNo}&authkey=${request.authCode}`;
      return ApiServiceWrapper.get(endpoint);
    },
    multiactivation(context: ActionContext<ProductsStoreState, RootStoreState>, req: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/multi-key-activation';
      return ApiServiceWrapper.post(endpoint, req);
    },
    getMultiActivationStatus(context: ActionContext<ProductsStoreState, RootStoreState>, userid: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/multi-key-activation-status?username=${userid}`;
      return ApiServiceWrapper.get(endpoint);
    },
    activateHesService(context: ActionContext<ProductsStoreState, RootStoreState>, req: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'activate-hes-service';
      return ApiServiceWrapper.post(endpoint, req);
    },
    getProductToDoList(context: ActionContext<ProductsStoreState, RootStoreState>, serialNumber: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `get-todo-list?serialNumber=${serialNumber}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getCountryList(context: ActionContext<ProductsStoreState, RootStoreState>, serialNumber: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/WCMCountries?serialNumber=${serialNumber}`;
      return ApiServiceWrapper.get(endpoint);
    },
    updateWCM(context: ActionContext<ProductsStoreState, RootStoreState>, req: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/UpdateWCMCountry';
      return ApiServiceWrapper.post(endpoint, req);
    },
    getServiceInfo(context: ActionContext<ProductsStoreState, RootStoreState>, serialNumber: string) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/serviceinfo?serial=${serialNumber}`;
      return ApiServiceWrapper.get(endpoint);
    },
    editProductInDB(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/product-rename';
      const req = {
        prodsRenamelist: [payload],
      };
      return ApiServiceWrapper.post(endpoint, req);
    },
    editttServer(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/ttserverfqdn?serial=${payload.serialNumber}`;
      let req : any;
      if (payload.strMode) {
        req = {
          policyServerUrl: payload.policyServerUrl,
          ttServerFQDN: payload.ttServerFQDN,
          userName: context.rootGetters.getUserId,
          strMode: payload.strMode,
        };
      } else {
        req = {
          policyServerUrl: payload.policyServerUrl,
          ttServerFQDN: payload.ttServerFQDN,
          userName: context.rootGetters.getUserId,
        };
      }
      return ApiServiceWrapper.put(endpoint, req);
    },
    updateZT(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      let endpoint = `users/update-ZTValue?ztValue=${payload.ztValue}&serialNumber=${payload.serialNumber}&isoverRide=${payload.isoverRide}`;
      if (payload.dc) {
        endpoint = `${endpoint}&strDatacenter=${payload.dc}`;
      }
      return ApiServiceWrapper.get(endpoint);
    },
    updateZtMultiple({ }, payload: any) {
      const endpoint = 'users/update-MultiZTValues';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    transferSerToCustomer({ }, payload) {
      const endpoint = 'products/manage-products';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    transferSerToUser({ }, payload) {
      const endpoint = `product/product-transfer?overrideTransferValidate=${payload.overrideTransferValidate}`;
      return ApiServiceWrapper.post(endpoint, payload.request);
    },
    deleteProduct({ }, payload) {
      const endpoint = `product/product-delete?overrideDeleteValidate=${payload.overrideDeleteValidate}`;
      return ApiServiceWrapper.post(endpoint, payload.request);
    },
    uploadCsv({ }, payload) {
      const endpoint = 'product/update-serial-firmware-friendlyname';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    getAssociatedProducts(context: ActionContext<ProductsStoreState, RootStoreState>, associatedTypeID: string) {
      context.commit('startLoading', null, { root: true });
      const userId = context.rootGetters.getUserId;
      // tslint:disable-next-line
      const endpoint = `product/get-associated-products?serialNumber=${context.state.productDetails.serialNumber}&userName=${userId}&prodAssocTypeID=${associatedTypeID}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getProductsForAssociation(context: ActionContext<ProductsStoreState, RootStoreState>, associatedTypeID: string) {
      context.commit('startLoading', null, { root: true });
      const userId = context.rootGetters.getUserId;
      // tslint:disable-next-line
      const endpoint = `product/get-products-for-association?serialNumber=${context.state.productDetails.serialNumber}&userName=${userId}&prodAssocTypeID=${associatedTypeID}`;
      return ApiServiceWrapper.get(endpoint);
    },
    addProductAssocition(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/product-association';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    registerSoftware(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/register-software';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    removeProductAssocition(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/product-association';
      return ApiServiceWrapper.delete(endpoint, payload);
    },
    activateService(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      window.parent.postMessage({
        reloadCSC : true,
      },                        '*');
      const endpoint = 'product/activate-service';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    getServiceStatus(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/service-status?serial=${payload.serialNumber}&serviceID=${payload.rootServiceID}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getCasApplication(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `casb-application?key=${payload.activationKey}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getSoftwareTrials(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `firmware/get-software-free-trials?productGroupId=${payload.productGroupId}`;
      return ApiServiceWrapper.get(endpoint);
    },
    multipleRegistration(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      const endpoint = 'product/multi-product-registration';
      const response = ApiServiceWrapper.post(endpoint, payload);
      context.commit('assignBatchid', response.batchid);
      return response;
    },
    multipleRegistrationstatus(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      const endpoint = `product/multi-product-registration-status?username=${payload.username}&batchid=${context.getters.getBatchid}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getCASDataCenter(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      let serviceID = payload.serviceId;
      let endpoint: any = {};
      if (payload.serviceID === '402') {
        serviceID = '';
      }
      if (payload.productID === '403') {
        endpoint = 'get-cas-datacenter?source=SASE';
      } else {
        endpoint = `get-cas-datacenter?serviceId=${serviceID}`;
      }
      return ApiServiceWrapper.get(endpoint);
    },
    tryNowApi(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'firmware/try-now';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    getTenantDetail(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/get-tenant-details';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    updateTenantLSG(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/update-tenant-lsginfo';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    getFirmwareList(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const userId = context.rootGetters.getUserId;
      // tslint:disable-next-line:max-line-length
      const endpoint = `downloads?serial=${payload.serialNumber}&username=${userId}&swLangCode=${payload.languageCode}&appName=${payload.appName}&oemCode=${payload.oemCode}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getTermsAndConditions(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const userId = context.rootGetters.getUserId;
      let endpoint = '';
      if (userId === 'ANONYMOUS') {
        endpoint = 'downloads/get-termsconditions';
      } else {
        endpoint = `downloads/get-downloadtermsconditions?username=${userId}`;
      }
      endpoint = `${endpoint}&swId=${payload.swId}&tncId=${payload.tncId}&oemCode=SNWL`;
      return ApiServiceWrapper.get(endpoint);
    },
    getProductGroupList(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/list-product-groups?serialnumber=${payload.serialNumber}&applicationFunctionality=ACCESSTYPEPRODMGMT`;
      return ApiServiceWrapper.get(endpoint);
    },
    changeTenantForProduct(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'products/update-tenant';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    getCaptureDatacenter(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `get-capture-datacenter?customerTaskId=${payload.customerTaskId}&datacenter=YES`;
      return ApiServiceWrapper.get(endpoint);
    },
    completeTodoList(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'complete-todo-list';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    getPhysicalAddress(context: ActionContext<ProductsStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'get-unit-address';
      return ApiServiceWrapper.get(endpoint);
    },
    getCountries(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any = { isWCM: false }) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `get-country?languageCode=EN&isWCM=${payload.isWCM}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getStates(context: ActionContext<ProductsStoreState, RootStoreState>, payload: { [key: string]: string }) {
      context.commit('startLoading', null, { root: true });
      return StateList[payload.countryCode];
    },
    manageCaptureDC(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `get-managecat-datacenter?customerTaskId=${payload.customerTaskId}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getEmailEncryptionDC(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `get-email-encryption-datacenter?customerTaskId=${payload.customerTaskId}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getHESDataCenter(context: ActionContext<ProductsStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'get-hes-data-center';
      return ApiServiceWrapper.get(endpoint);
    },
    getHESSerialNumberDetail(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `get-hes-serial-number-datacenter-details?serialNumber=${payload.serialNumber}`;
      return ApiServiceWrapper.get(endpoint);
    },
    activateHES(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'activate-hes-service';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    goToHESConsole(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `openhesconsole?serialNumber=${payload.serialNumber}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getNsvPlatforms(context: ActionContext<ProductsStoreState, RootStoreState>) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'get-nsv-platforms';
      return ApiServiceWrapper.get(endpoint);
    },
    submitProductPlatform(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'register-nsv-serialnumber';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    deleteProductAssociation(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/product-association';
      return ApiServiceWrapper.delete(endpoint, payload);
    },
    firewallManagementOption(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/firewallmanagementoptions';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    getTenantInfo(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `products/get-tenant-address-info?productGroupId=${payload.productGroupId}`;
      return ApiServiceWrapper.get(endpoint);
    },
    updateTenantInfo({ }, payload) {
      const endpoint = 'products/update-tenant-address';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    updateGUID(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/guid?serial=${payload.serNo}`;
      return ApiServiceWrapper.put(endpoint, payload.guidBody);
    },
    deleteGUID(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/deleteguid?serial=${payload.serNo}&userName=${payload.userName}`;
      return ApiServiceWrapper.delete(endpoint);
    },
    getBackupPref(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/backupPrefs?serial=${payload.serialNumber}`;
      return ApiServiceWrapper.get(endpoint);
    },
    addPrefFile(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/uploadpreffile';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    bacupPrefOperation(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/backupPrefOperation';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    backupPrefOperationToggleGold(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/backupPrefOperation?fileid=${payload.fileId}&operation=tgold&serial=${payload.serNo}`;
      return ApiServiceWrapper.get(endpoint);
    },
    backupPrefOperationToggleLock(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/backupPrefOperation?fileid=${payload.fileId}&operation=tlock&serial=${payload.serNo}`;
      return ApiServiceWrapper.get(endpoint);
    },
    backupPrefOperationDelete(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/backupPrefOperation?fileid=${payload.fileId}&operation=del&serial=${payload.serNo}`;
      return ApiServiceWrapper.get(endpoint);
    },
    downloadPrefFile(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/downloadpreffile?serial=${payload.serNo}&fileId=${payload.fileId}`;
      return ApiServiceWrapper.get(endpoint);
    },
    enableCloseNetwork(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/enable-closed-network';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    generateCNFiles(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/generate-closed-network-files';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    checkKeySet(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/licensesKeyset?username=${payload.username}&serial=${payload.serial}&strAccessCode=${payload.accessCode}`;
      return ApiServiceWrapper.get(endpoint);
    },
    assignToken(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `product/Generate-Assign-Token?serialNumber=${payload.serialNumber}`;
      return ApiServiceWrapper.get(endpoint);
    },
    requestToDownloadClosedNetworkFirmware(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `downloads/get-csafirmware-downloads?username=${payload.username}&sessionID=${payload.sessionID}&serialNumber=${payload.serialNumber}`;
      return ApiServiceWrapper.get(endpoint);
    },
    requestToDownloadClosedNetworkSignature(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      // tslint:disable-next-line
      const endpoint = `downloads/get-csasmashupgrade-downloads?username=${payload.username}&sessionID=${payload.sessionID}&serialNumber=${payload.serialNumber}`;
      return ApiServiceWrapper.get(endpoint);
    },
    getInstances(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'products/manage-volume-licences';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    updateCountry(context: ActionContext<ProductsStoreState, RootStoreState>, payload: any) {
      const endpoint = 'product/update-gen7wireless-country';
      context.commit('startLoading', null, { root: true });
      return ApiServiceWrapper.post(endpoint, payload);
    },
    deleteInstance(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'products/manage-volume-licences';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    createInstance(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'products/manage-volume-licences';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    registerSMASerial(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'register-sma8200v-serialnumber';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    enrollDerollMssp(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'mssp/allocatemsspproductservices';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    generateCSCCode(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      const req = {
        tenantId : payload.tenant || '',
        tileName: payload.tileName,
      };
      context.commit('startLoading', null, { root: true });
      const endpoint = 'generate-cscaccesscode';
      return ApiServiceWrapper.post(endpoint, req);
    },
    getProductServicesList(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = `mssp/applicable-mssp-product-services?TenantID=${payload.tenantid}&serialNumber=${payload.serialNumber}&Mode=ENROLL`;
      return ApiServiceWrapper.get(endpoint);
    },
    approveOrRejectITT(context: ActionContext<ProductsStoreState, RootStoreState>, payload) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'product/ApproveDecline-Tenant-Transfer';
      return ApiServiceWrapper.post(endpoint, payload);
    },
    // checkIfUserIsReadOnly(context: ActionContext<ProductsStoreState, RootStoreState>) {
    //   // context.commit('startLoading', null, { root: true });
    //   context.commit('setUserReadStatus', true);
    // },
  },
  getters: {
    getCustomersList: state => state.customersList,
    getSecureUpdateData: state => state.secureUpdateData,
    getRegisterOrTransfer: state => state.registerOrTransfer,
    getUniqueID: state => state.uniqueID,
    getAssignToken: state => state.assignToken,
    getAwsSerialNumber: state => state.awsSerialNumber,
    getSecureUpgrade: state => state.secureUpgrade,
    getSecureUpdateSelected: state => state.secureUpdateSelected,
    getFreeTrailSerNo: state => state.freeTrailSerNo,
    getStorageSata: state => state.storageSata,
    getBatchid: state => state.batchid,
    getInitialFiltersState: state => state.initial,
    getWidths: state => state.widths,
    getSkipLoadingInfo: state => state.skipLoading,
    getZtnaMsg:state => state.ztnaMsg,
    getValidateSerialNumberData: state => state.validateSerialNumberData,
    // getRegisterProductView: state => state.registerProductView,
    // getDefaultTabView: state => state.defaultTabView,
    // getCreateCustomerView: state => state.createCustomerView,
    // getTest: state => state.isUserRead,
  },
  namespaced: true,
} as Module<ProductsStoreState, RootStoreState>;
